import PropTypes from "prop-types";

const _TimeZoneUL = PropTypes.shape({
  time_zone_li: PropTypes.string,
});

const _Sizes = PropTypes.shape({
  thumbnail: PropTypes.string,
  "thumbnail-width": PropTypes.number,
  "thumbnail-height": PropTypes.number,
  "16:9": PropTypes.string,
  "16:9-width": PropTypes.number,
  "16:9-height": PropTypes.number,
  "1:1": PropTypes.string,
  "1:1-width": PropTypes.number,
  "1:1-height": PropTypes.number,
  "3:2": PropTypes.string,
  "3:2-width": PropTypes.number,
  "3:2-height": PropTypes.number,
  hero: PropTypes.string,
  "hero-width": PropTypes.number,
  "hero-height": PropTypes.number,
  thumb: PropTypes.string,
  "thumb-width": PropTypes.number,
  "thumb-height": PropTypes.number,
});

const _TimeGalleryImg = PropTypes.shape({
  ID: PropTypes.number,
  id: PropTypes.number,
  title: PropTypes.string,
  filename: PropTypes.string,
  filesize: PropTypes.number,
  url: PropTypes.string,
  link: PropTypes.string,
  alt: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string,
  caption: PropTypes.string,
  name: PropTypes.string,
  status: PropTypes.string,
  uploaded_to: PropTypes.number,
  date: PropTypes.string,
  modified: PropTypes.string,
  menu_order: PropTypes.number,
  mime_type: PropTypes.string,
  type: PropTypes.string,
  subtype: PropTypes.string,
  icon: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  sizes: _Sizes,
});

const _TimeZoneGallery = PropTypes.shape({
  time_gallery_img: _TimeGalleryImg,
  time_zone_title: PropTypes.string,
  time_zone_countries: PropTypes.string,
  time_clock_format: PropTypes.string,
});

const _TimeZone = PropTypes.shape({
  acf_fc_layout: PropTypes.string,
  custom_padding: PropTypes.bool,
  custom_top: PropTypes.number,
  custom_bottom: PropTypes.number,
  time_zone_gallery: PropTypes.arrayOf(_TimeZoneGallery),
});

export const TimeZonePropTypes = {
  data: PropTypes.oneOfType([_TimeZone, PropTypes.any]),
};

export const TimeZoneListPropTypes = {
  timeZoneListContent: PropTypes.arrayOf(_TimeZoneUL),
};

export const TimeZonesPropTypes = {
  timeZoneGallery: PropTypes.arrayOf(_TimeZoneGallery),
};
